import { z } from 'zod'

export const ASYNC_REPORT_STATUS = {
  generating: 'generating',
  done: 'done',
  error: 'error',
} as const

export type AsyncReportStatus =
  (typeof ASYNC_REPORT_STATUS)[keyof typeof ASYNC_REPORT_STATUS]

export const asyncReportSchema = z.object({
  id: z.string(),
  report_url: z.string().nullable(),
  status: z.enum([
    ASYNC_REPORT_STATUS.generating,
    ASYNC_REPORT_STATUS.done,
    ASYNC_REPORT_STATUS.error,
  ]),
  format: z.enum(['excel', 'word', 'csv']),
  created_at: z.string(),
  file_name: z.string(),
})

export type AsyncReport = z.infer<typeof asyncReportSchema>
